// extracted by mini-css-extract-plugin
module.exports = {"root":"_18z5D","collapsed":"qJvXx"};